module.exports = __webpack_public_path__ + "static/media/oj.e3648872.jpg";